import React, { useState, useRef, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useTheme,
  Box,
} from "@mui/material";

const PinModal = ({
  open,
  onClose,
  onSuccess,
  title = "Verifikasi Keamanan",
  subtitle = "Masukkan 6 digit PIN untuk melanjutkan aksi ini.",
  correctPin = "123456",
}) => {
  const theme = useTheme();
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState(false);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (open) {
      setPin(["", "", "", "", "", ""]);
      setError(false);
      setTimeout(() => inputRefs.current[0]?.focus(), 100);
    }
  }, [open]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    
    if (/^[0-9]$/.test(value)) {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);
      setError(false);

      if (index < 5) {
        inputRefs.current[index + 1].focus();
      } else {
        const fullPin = newPin.join("");
        validatePin(fullPin);
      }
    }
  };

  const validatePin = async (pinString) => {
    if (correctPin) {
      if (pinString === correctPin) {
        setError(false);
        onClose();
        if (onSuccess) onSuccess(pinString);
      } else {
        handlePinError();
      }
    } else {
      try {
        const isSuccess = await onSuccess(pinString);
        if (isSuccess !== false) {
          onClose();
        } else {
          handlePinError();
        }
      } catch (err) {
        handlePinError();
      }
    }
  };

  const handlePinError = () => {
    setError(true);
    setPin(["", "", "", "", "", ""]);
    inputRefs.current[0]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newPin = [...pin];
      if (pin[index] !== "") {
        newPin[index] = "";
        setPin(newPin);
      } else if (index > 0) {
        newPin[index - 1] = "";
        setPin(newPin);
        inputRefs.current[index - 1].focus();
      }
      setError(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography mb={2}>{subtitle}</Typography>
        
        <Box display="flex" justifyContent="center" gap={1.5} my={4}>
          {pin.map((digit, index) => (
            <input
              key={index}
              type="password"
              maxLength="1"
              value={digit}
              ref={(el) => (inputRefs.current[index] = el)}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              style={{
                width: "48px",
                height: "60px",
                fontSize: "28px",
                textAlign: "center",
                borderRadius: "8px",
                border: `2px solid ${
                  error ? theme.palette.error.main : theme.palette.secondary[300]
                }`,
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.primary,
                outline: "none",
                transition: "border-color 0.2s",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = theme.palette.secondary.main;
                e.target.select();
              }}
              onBlur={(e) => {
                e.target.style.borderColor = error
                  ? theme.palette.error.main
                  : theme.palette.secondary[300];
              }}
            />
          ))}
        </Box>
        
        {error && (
          <Typography color="error" textAlign="center" fontWeight="bold">
            PIN salah. Silakan coba lagi.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="inherit"
          onClick={onClose}
          sx={{ fontSize: "14px", fontWeight: "bold", padding: "10px 20px" }}
        >
          Batal
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PinModal;
